import { memo, useEffect } from 'react';
import { Layer, Source, useMap } from 'react-map-gl/mapbox';
import { useRecoilValue } from 'recoil';
import { TELEMETRY_ARROW_LAYER_STYLE, TELEMETRY_LAYER_STYLE } from '../../../constants/map';
import { activeTelemetryState, reportTelemetryLngLatsState } from '../../../storage/reports';

function TelemetryLayer() {
  const { map } = useMap();
  const assetId = useRecoilValue(activeTelemetryState);
  const lngLats = useRecoilValue(reportTelemetryLngLatsState(assetId || ''));
  const geojson: GeoJSON.Feature = {
    type: 'Feature',
    properties: {},
    geometry: {
      type: 'LineString',
      coordinates: lngLats,
    },
  };

  useEffect(() => {
    if (!map) return;
    const arrowUrl = '/img/icons/map/arrow.png';
    map.loadImage(`${arrowUrl}`, (error, image) => {
      if (error) {
        return;
      }
      if (image && !map.hasImage('arrow')) {
        map.addImage('arrow', image);
      }
    });
  }, [map]);

  if (!assetId) return null;

  return (
    <Source
      type="geojson"
      data={geojson}
      id="telemetry"
    >
      <Layer {...TELEMETRY_LAYER_STYLE} />
      <Layer {...TELEMETRY_ARROW_LAYER_STYLE} />
    </Source>
  );
}

export default memo(TelemetryLayer);
